module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.09c7cc13.webp";